export const SalesChannelType = [
  {
    id: 'D2D',
    value: 'D2D',
    type: 'salesChannelType',
  },
  {
    id: 'TELEMARKETING',
    value: 'TELEMARKETING',
    type: 'salesChannelType',
  },
  {
    id: 'KIOSK',
    value: 'KIOSK',
    type: 'salesChannelType',
  },
  {
    id: 'LEADGEN',
    value: 'LEADGEN',
    type: 'salesChannelType',
  },
  {
    id: 'OTM',
    value: 'OTM',
    type: 'salesChannelType',
  },
]
